import axios from '@/utils/request';

// 获取资源列表
export const getKnowledges = (data: any) => {
  return axios.request({
    url: 'Knowledge/GetKnowledges',
    method: 'GET',
    params: data,
  });
};

// 获取资源目录树
export const getCatalogTree = (data: any) => {
  return axios.request({
    url: 'Knowledge/GetCatalogTree',
    method: 'GET',
    params: data,
  });
};

// 获取资源详情
export const getKnowledgeDetails = (data: any) => {
  return axios.request({
    url: 'Knowledge/GetKnowledgeDetails',
    method: 'GET',
    params: data,
  });
};

// 获取资源详情
export const postKnowledgeEvaluation = (data: any) => {
  return axios.request({
    url: 'Knowledge/PostKnowledgeEvaluation',
    method: 'POST',
    data,
  });
};

// 获取相关资源
export const getRelatedKnowledges = (data: any) => {
  return axios.request({
    url: 'Knowledge/GetRelatedKnowledges',
    method: 'GET',
    params: data,
  });
};
